import { createTheme, timeline } from '@abbyy/theming';
import { blue, grey } from '@mui/material/colors';

export const theme = createTheme({
    ...timeline.lightTheme,
    palette: {
        ...timeline.lightTheme.palette,
        info: {
            light: blue.A100,
            main: blue.A400,
            dark: blue.A700,
            contrastText: blue[900]
        },
        warning: {
            ...timeline.lightTheme.palette.warning,
            main: '#ce5918'
        },
        primary: {
            light: '#7fd9e1',
            main: '#2baab5',
            dark: '#8097a2',
            contrastText: timeline.lightTheme.palette.primary.contrastText
        },
        text: {
            ...timeline.lightTheme.palette.text,
            hint: '#cb5a25',
            primary: '#333333'
        }
    },
    components: {
        MuiCssBaseline: {
            styleOverrides: {
                body: {
                    fontFamily:
                        '"Source Sans Pro", "ヒラギノ角ゴ ProN" , "Hiragino Kaku Gothic ProN" , "游ゴシック" , "游ゴシック体" , YuGothic , "Yu Gothic" , "メイリオ" , Meiryo , "ＭＳ ゴシック" , "MS Gothic" , HiraKakuProN-W3 , "TakaoExゴシック" , TakaoExGothic , "MotoyaLCedar" , "Droid Sans Japanese" , sans-serif',
                    lineHeight: 1.5,
                    fontSize: '16px'
                }
            }
        },
        MuiTableCell: {
            styleOverrides: {
                root: {
                    fontSize: '16px',
                    borderBottomColor: grey[300]
                }
            }
        },
        MuiSelect: {
            styleOverrides: {
                select: {
                    paddingTop: '6px',
                    paddingBottom: '8px',
                    paddingLeft: '6px',
                    backgroundColor: '#fff'
                }
            }
        },
        MuiSwitch: {
            styleOverrides: {
                switchBase: {
                    '&$checked + $track': {
                        backgroundColor: '#2baab5 !important',
                        borderColor: '#2baab5 !important',
                        opacity: 1
                    },
                    '&$checked:hover + $track': {
                        backgroundColor: '#21838c !important',
                        borderColor: '#21838c !important'
                    }
                }
            }
        },
        MuiCheckbox: {
            styleOverrides: {
                colorPrimary: {
                    color: `#000`,
                    '&&$checked': {
                        color: '#2baab5',
                        '&&:hover': {
                            color: '#21838c'
                        }
                    }
                },
                indeterminate: {
                    color: '#2baab5 !important'
                }
            }
        },
        MuiRadio: {
            styleOverrides: {
                root: {
                    '&$checked': {
                        fill: '#2baab5',
                        color: '#2baab5'
                    }
                }
            }
        },
        MuiFormControlLabel: {
            styleOverrides: {
                label: {
                    color: '#707070 !important',
                    fontSize: '14px !important'
                }
            }
        },
        MuiPopover: {
            styleOverrides: {
                paper: {
                    boxShadow:
                        '0px 5px 5px -3px rgb(0 0 0 / 20%), 0px 8px 10px 1px rgb(0 0 0 / 14%), 0px 3px 14px 2px rgb(0 0 0 / 12%)'
                }
            }
        }
    }
});
